/**
 * Levenshtein Distance 기반 유사도 계산.
 * 중복 segment 필터링에 사용 — 동일 플랫폼 구현 참고:
 * - Android: https://github.com/hyperconnect/azar-android/blob/b6c11bf/app/src/main/java/com/azarlive/android/util/stt/ManualSegmentActor.kt#L368-L397
 * - iOS: https://github.com/hyperconnect/azar-ios/blob/bae9b42/Azar/Feature/Discover/MatchVideoChat/MatchVideoChatSTTProvider.swift#L383-L427
 */
function levenshteinDistance(source: string, target: string): number {
  const sourceLen = source.length;
  const targetLen = target.length;

  if (sourceLen === 0) return targetLen;
  if (targetLen === 0) return sourceLen;

  let previousRow = Array.from({ length: targetLen + 1 }, (_, i) => i);
  let currentRow = new Array<number>(targetLen + 1);

  for (let i = 1; i <= sourceLen; i++) {
    currentRow[0] = i;
    const sourceChar = source[i - 1];

    for (let j = 1; j <= targetLen; j++) {
      const cost = sourceChar === target[j - 1] ? 0 : 1;
      currentRow[j] = Math.min(
        previousRow[j] + 1,
        currentRow[j - 1] + 1,
        previousRow[j - 1] + cost
      );
    }

    [previousRow, currentRow] = [currentRow, previousRow];
  }

  return previousRow[targetLen];
}

export function calculateSimilarity(text1: string, text2: string): number {
  const a = text1.trim();
  const b = text2.trim();

  if (a === b) return 1.0;
  if (a.length === 0 || b.length === 0) return 0.0;

  const maxLength = Math.max(a.length, b.length);
  const distance = levenshteinDistance(a, b);
  return 1.0 - distance / maxLength;
}
